import React, { useMemo } from 'react';
import OldAndPdfStudioReaderPage from './OldAndPdfStudioReaderPage';
import AbsoluteReaderPage from './AbsoluteReaderPage';

/**
 * ReaderPage Dispatcher:
 * - 'absolute_html' -> AbsoluteReaderPage (S3 streaming, live download speed tracker, DOM virtualization, new reader UI)
 * - 'pdf_studio_converted' / 'html_old_ebook' / standard books -> OldAndPdfStudioReaderPage (chapter-by-chapter reader with TOC hierarchy)
 */
const ReaderPage = (props) => {
  const { book } = props;

  const isAbsoluteHtml = useMemo(() => {
    const type = book?.html_type || book?.conversion_type;
    if (type === 'absolute_html') return true;
    if (type === 'pdf_studio_converted' || type === 'html_old_ebook') return false;
    // Fallback detection for imported books
    return Boolean(book?.is_external && !book?.pdfstudio);
  }, [book]);

  if (isAbsoluteHtml) {
    return <AbsoluteReaderPage {...props} />;
  }

  return <OldAndPdfStudioReaderPage {...props} />;
};

export default ReaderPage;